import React from 'react';
import { useDetails } from './useDetails';
import { PERMISSIONS } from 'constants/permissions';
import { EditIconButton } from 'components/common/icons';
import { HasAccess } from 'components/common/accessControl';
import { StatusBadge } from 'components/common/StatusBadge';
import { Button, Col, PriorityTag, Row, Tag, Typography } from 'components';
import styles from './styles.module.scss';
import { TaskEditModal } from './edit';
import moment from 'moment';

export const Details = React.memo(() => {
  const { onUpdateClick, taskDetails, onEntityClick, openEditModal, onCloseUpdateClick } = useDetails();
  const entityType = taskDetails.entityType
    ? taskDetails.entityType.charAt(0).toUpperCase() + taskDetails.entityType.slice(1).toLowerCase()
    : '';
  return (
    <>
      <Row gutter={[0, 16]}>
        <Col span={24} className={styles.main_info}>
          <Row justify={'space-between'} wrap={false}>
            <Col span={20}>
              <Row gutter={[0, 4]}>
                <Col span={24} style={{ marginTop: 5 }} className={styles.legal_name}>
                  <Typography.Text className={styles.name}>ID: {taskDetails.uuid}</Typography.Text>
                </Col>
                <Col span={24}>{taskDetails?.status ? <StatusBadge type={taskDetails?.status} /> : ''}</Col>
                <Col span={24}>
                  <Row>
                    <Typography.Text style={{ color: '#99A0AE' }}>{taskDetails.email}</Typography.Text>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col>
              <HasAccess role={PERMISSIONS.tasks.task.write}>
                <Button type={'link'} icon={<EditIconButton />} onClick={onUpdateClick} />
              </HasAccess>
            </Col>
          </Row>
          <Row className={'margin-t-4'}>
            <Col span={24}>
              <Row className={'gap-8'} wrap={false} align={'middle'}>
                <Typography.Text className={'font-size-12'} style={{ color: '#99A0AE' }}>
                  {taskDetails.formattedCreateDate}
                </Typography.Text>
                <Typography.Text className={'font-size-12'} style={{ color: '#99A0AE' }}>
                  {taskDetails.formattedLastModifiedDate}
                </Typography.Text>
              </Row>
            </Col>
            <Col span={24}>
              <Row align={'middle'} style={{ marginTop: 12 }}>
                <Typography.Text type={'secondary'}>
                  CREATED BY <br />
                  {taskDetails._createdBy?.firstName} {taskDetails._createdBy?.lastName}
                </Typography.Text>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24} className={styles.main_info}>
          <Row justify={'space-between'}>
            <Typography.Text className={styles.info_item} type={'secondary'}>
              Assign To
            </Typography.Text>
            <Typography.Text className={styles.info_item} type={'secondary'}>
              {taskDetails._assignedTo?.firstName} {taskDetails._assignedTo?.lastName}
            </Typography.Text>
          </Row>
          <Row justify={'space-between'}>
            <Typography.Text className={styles.info_item} type={'secondary'}>
              Due Date
            </Typography.Text>
            <Typography.Text className={styles.info_item} type={'secondary'}>
              {moment(taskDetails.dueDate).format('DD.MM.YYYY HH:mm')}
            </Typography.Text>
          </Row>
          <Row justify={'space-between'}>
            <Typography.Text className={styles.info_item} type={'secondary'}>
              Priority
            </Typography.Text>
            <Typography.Text className={styles.info_item} type={'secondary'}>
              {taskDetails.priorityLevel ? <PriorityTag type={taskDetails.priorityLevel} /> : '-'}
            </Typography.Text>
          </Row>
          <Row justify={'space-between'}>
            <Typography.Text style={{ fontSize: 14 }} type={'secondary'}>
              Entity
            </Typography.Text>
            <Typography.Text style={{ fontSize: 14 }} type={'secondary'}>
              {taskDetails.entityType ? (
                <Tag
                  title={`${entityType}:${taskDetails?.entityValue || taskDetails?.entityId}`}
                  onClick={
                    taskDetails?.entityId
                      ? () => onEntityClick(taskDetails.entityType, taskDetails.entityId)
                      : undefined
                  }
                  className={styles.entity_tag}
                  color={'#E1E4EA'}
                >
                  {`${entityType}:${taskDetails?.entityValue || taskDetails?.entityId}`}
                </Tag>
              ) : (
                'Not Set'
              )}
            </Typography.Text>
          </Row>
        </Col>
      </Row>
      <TaskEditModal open={openEditModal} onCancel={() => onCloseUpdateClick()} />
    </>
  );
});
